import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import WebhookEventsAdmin from 'pages/Landing/admin/WebhookEventsAdmin'

export const Route = createFileRoute('/_auth/_global/webhook-events')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: WebhookEventsAdmin,
})
